module.exports = [{
      plugin: require('../node_modules/gatsby-source-prismic/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"ilyf","schemas":{"image_post":{"Main":{"image":{"type":"Image","config":{"constraint":{},"thumbnails":[],"label":"image"}}}}}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/site_icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"280d4bfce1278a607072132275c6c375"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
